import { createGlobalStyle } from 'styled-components';
import { accent } from 'constants/theme';
import nmLightWoff2 from './assets/fonts/neueMontreal/NeueMontreal-Light.woff2';
import nmLightWoff from './assets/fonts/neueMontreal/NeueMontreal-Light.woff';
import nmLightItalicWoff2 from './assets/fonts/neueMontreal/NeueMontreal-LightItalic.woff2';
import nmLightItalicWoff from './assets/fonts/neueMontreal/NeueMontreal-LightItalic.woff';
import nmBoldItalicWoff2 from './assets/fonts/neueMontreal/NeueMontreal-BoldItalic.woff2';
import nmBoldItalicWoff from './assets/fonts/neueMontreal/NeueMontreal-BoldItalic.woff';
import nmBoldWoff2 from './assets/fonts/neueMontreal/NeueMontreal-Bold.woff2';
import nmBoldWoff from './assets/fonts/neueMontreal/NeueMontreal-Bold.woff';

import nmRegularWoff2 from './assets/fonts/neueMontreal/NeueMontreal-Regular.woff2';
import nmRegularWoff from './assets/fonts/neueMontreal/NeueMontreal-Regular.woff';

import nmItalicWoff2 from './assets/fonts/neueMontreal/NeueMontreal-Italic.woff2';
import nmItalicWoff from './assets/fonts/neueMontreal/NeueMontreal-Italic.woff';

import nmMediumWoff2 from './assets/fonts/neueMontreal/NeueMontreal-Medium.woff2';
import nmMediumWoff from './assets/fonts/neueMontreal/NeueMontreal-Medium.woff';

import nmMediumItalicWoff2 from './assets/fonts/neueMontreal/NeueMontreal-MediumItalic.woff2';
import nmMediumItalicWoff from './assets/fonts/neueMontreal/NeueMontreal-MediumItalic.woff';

export default createGlobalStyle`

@font-face {
    font-family: 'Neue Montreal';
    src: url(${nmRegularWoff2}) format('woff2'),
        url(${nmRegularWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Neue Montreal';
    src: url(${nmItalicWoff2}) format('woff2'),
        url(${nmItalicWoff}) format('woff');
    font-weight: normal;
    font-style: italic;
}

@font-face {
    font-family: 'Neue Montreal';
    src: url(${nmMediumWoff2}) format('woff2'),
        url(${nmMediumWoff}) format('woff');
    font-weight: 500;
    font-style: normal;
}


@font-face {
    font-family: 'Neue Montreal';
    src: url(${nmMediumItalicWoff2}) format('woff2'),
        url(${nmMediumItalicWoff}) format('woff');
    font-weight: 500;
    font-style: italic;
}

  @font-face {
    font-family: 'Neue Montreal';
    src: url(${nmLightWoff2}) format('woff2'),
        url(${nmLightWoff}) format('woff');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'Neue Montreal';
    src: url(${nmLightItalicWoff2}) format('woff2'),
        url(${nmLightItalicWoff}) format('woff');
    font-weight: 300;
    font-style: italic;
}

@font-face {
    font-family: 'Neue Montreal';
    src: url(${nmBoldItalicWoff2}) format('woff2'),
        url(${nmBoldItalicWoff}) format('woff');
    font-weight: bold;
    font-style: italic;
}

@font-face {
    font-family: 'Neue Montreal';
    src: url(${nmBoldWoff2}) format('woff2'),
        url(${nmBoldWoff}) format('woff');
    font-weight: bold;
    font-style: normal;
}

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  html {
    font-size: 100%;
  }

  body {
    font-family: 'Neue Montreal', -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
    line-height: 1;
    // font-size: 1.6rem;
    color: white;
    background-color: #1c1c20;

    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "pnum";
    font-feature-settings: "pnum";
    font-variant-numeric: proportional-nums;
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  a {
    color: ${accent};
  }

  pre {
    display: block;
    padding: 2rem;
    margin-top: 4rem;
    overflow: auto;
    font-size: 85%;
    line-height: 1.45;
    border-radius: 5px;
    color: ${accent};
    border: 1px solid #ddd;
    font-family: "SFMono-Regular",Consolas,"Liberation Mono",Menlo,Courier,monospace;
  }

  video {
    max-width: 100%;
  }

  p {
    margin-bottom: 2rem;
  }

  html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,html [type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}template{display:none}[hidden]{display:none}

.clearfix:after {visibility: hidden; display: block; font-size: 0; content: ''; clear: both; height: 0; }

html { -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box;}

*, *:before, *:after {box-sizing: inherit}

.visuallyHidden:not(:focus):not(:active) { position: absolute; width: 1px; height: 1px; margin: -1px;border: 0;padding: 0;white-space: nowrap;clip-path: inset(100%);clip: rect(00 0 0);overflow: hidden;}

html.has-scroll-smooth {
  overflow: hidden; }

html.has-scroll-dragging {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none; }

.has-scroll-smooth body {
  overflow: hidden; }

.has-scroll-smooth [data-scroll-container] {
  min-height: 100vh; }

.c-scrollbar {
  position: absolute;
  right: 0;
  top: 0;
  width: 11px;
  height: 100vh;
  transform-origin: center right;
  transition: transform 0.3s, opacity 0.3s;
  opacity: 0; }
  .c-scrollbar:hover {
    transform: scaleX(1.45); }
  .c-scrollbar:hover, .has-scroll-scrolling .c-scrollbar, .has-scroll-dragging .c-scrollbar {
    opacity: 1; }

.c-scrollbar_thumb {
  position: absolute;
  top: 0;
  right: 0;
  background-color: black;
  opacity: 0.5;
  width: 7px;
  border-radius: 10px;
  margin: 2px;
  cursor: -webkit-grab;
  cursor: grab; }
  .has-scroll-dragging .c-scrollbar_thumb {
  cursor: -webkit-grabbing;
  cursor: grabbing; }

  .blind {
    background-color: #1c1c20;
  }

  img {
    width: 200%;
  }

  p {
    font-size: 0.9rem;
    line-height: 1.4;
    padding: 0 10px;
  }

  h3 p {
    line-height: 1;
    font-size: 3.73vw;
  }

  h3 {
    font-size: 4vw;
  }

  h4 {
    font-size: 1.7rem;
    padding: 0 10px;
  }

  a {
    text-decoration: none;
  }

  .pointerAuto {
    pointer-events: auto;
  }

  body {
    overflow: hidden;
    min-width: 320px;
  }

  button {
    margin: 0;
    padding: 0;
    border: none;
    width: 100%;
    background-color: transparent;
    cursor: pointer;
  }

  button:focus, button:active {
    outline-color: rgba(255, 255, 255, 0.1) !important;
  }

  .stellarLogo {
    .cls-1 {
      fill: #ed2c3e;
    }
  }
`;
